export default "__VITE_ASSET__D3BJK8zN__"